import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
    providedIn: 'root',
})
export class FormHelper
{
    static touchForm(form: FormGroup, showControlMessage = false) {
        const controls = form.controls;
        Object.keys(controls).find((controlName) => {
            const control = controls[controlName];
            control.markAsTouched();
            control.updateValueAndValidity();

            if (showControlMessage && control.errors) {
                // set the value (again) to trigger watchers in control-messages component
                control.setValue(control.value);
            }

            if (control.hasOwnProperty('controls')) {
                this.touchForm(control as FormGroup, showControlMessage);
            }
        });
    }

}
